import * as yup from "yup";

export const controlObjectValidator = yup.object().shape({
	start_date: yup
		.date()
		.required("start_date is a required field")
		.nonNullable(),
	end_date: yup.date().required("end_date is a required field").nonNullable(),
});
